export default "__VITE_ASSET__651aff2a__"